export default __webpack_public_path__ + "menu-user-smop-icon.29b1ea56ce35db1de230a1804682655b.svg";